import React from "react"
import LeversMolecule from "views/molecules/recommendations/hypotheses/LeversMolecule"
import PropTypes from "prop-types"
import { RECOMMENDATIONS_LEVERS_DATA } from "utils/constants/recommendations/hypothesesData"

const HypothesesMolecule = ({ proposition }) => {
  // const leverData = RECOMMENDATIONS_LEVERS_DATA[proposition.lever]
  return <LeversMolecule items={proposition.simulation_proposition_levers} />
}

HypothesesMolecule.propTypes = {
  proposition: PropTypes.shape({
    pillar: PropTypes.string.isRequired,
    sdg: PropTypes.number.isRequired,
    topic: PropTypes.string.isRequired,
    kpi: PropTypes.string.isRequired,
    theme: PropTypes.string.isRequired,
    lever: PropTypes.string.isRequired,
    impact: PropTypes.string.isRequired,
    complexity: PropTypes.string.isRequired,
    simulation_detail: PropTypes.object.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
}

export default HypothesesMolecule
